import Repository from "./Repository";

export default {
  getAthletePaymentStates(payload) {
    return Repository.get(`athlete-annual-report/${payload}`);
  },
};
